// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__iYtAC","copyright":"Footer_copyright__tAa5S","promoCopy":"Footer_promoCopy__4egjP"};